module.exports = __webpack_public_path__ + "static/media/cabify-delivery-icon.50d6ba75.svg";